import { Text, Flex } from '@chakra-ui/react';
import { PageContent } from 'src/components/PageContent';
import { SectionBox } from 'src/components/SectionBox';
import { breadcrumb } from './breadcrumb';

export const ApplicationDesign = () => {
  return (
    <PageContent title='DESIGN DO APLICATIVO' breadcrumbItems={breadcrumb}>
      <SectionBox bodyProps={{ gap: 'small' }}>
        <Flex direction='column' gap='deka'>
          <Flex direction='column' gap={2}>
            <Text fontWeight='bold' color='brand.500'>
              Design do Aplicativo
            </Text>
            <Text color='text.main'>Configurações gerais de informação e identidade visual do aplicativo:</Text>
          </Flex>
        </Flex>
      </SectionBox>
    </PageContent>
  );
};
